module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAALlJREFUSEvNVdsNgCAMlHXcxGUcxmXcxHU0NSGpzfUBaCNfJECvd72WMn28CsXf9uPUcNZlvu9oy3ubC+BlG1WzsqJ4DwZpAJ6u2nlN0GWQBsAl41nxPXehykAWDwWrdyiIdo5qCD0eBZCJNQMgW3IGnwFE+4HumWMABeIOk2yGJUIBJaBMyiwy0vhVBsjXHFT2A5IUziLL516Xy8YzAXol6p5F0SK7AC0+t6yc/x9oo+H/f/Ko5tb7C/eDCCjwivklAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/app_img/icon_code.png
// module id = Krd7
// module chunks = 5